import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton, Typography
} from "@mui/material";
import { unwrapResult } from '@reduxjs/toolkit';
import { Form as AntForm, Input } from 'antd';
import { useState } from "react";
import { useDispatch } from "react-redux";
import Snackbars from '../../GlobalComponents/Alerts/Snackbars';
import GridContainer from "../../GlobalComponents/Grid/GridContainer";
import GridItem from "../../GlobalComponents/Grid/GridItem";
import H4 from "../../GlobalComponents/TypoGraphy/H4";
import { Colors } from "../../GlobalComponents/Utility/Colors";
import { internalUpdateStatutTicket } from "../../ReduxTLK/features/SAV/TicketSlice";
import { ESCALADE_TEAMS } from "../../utils/escaladeUtils";


// ─── Modal Changer d'équipe header (Dev → IT) ────────────────────
function HeaderChangeTeamModal({ open, onClose, activeInternalStatus, ticketId, onSuccess }) {
  const [form] = AntForm.useForm();
  const { TextArea } = Input;
  const dispatch = useDispatch();
  const allowedTeams   = ESCALADE_TEAMS.filter(t => t.type === 1); // IT uniquement
  const [selectedType, setSelectedType] = useState(allowedTeams[0]?.type ?? null);
  const [msg, setMsg]         = useState('');
  const [success, setSuccess] = useState(false);
  const [error,   setError]   = useState(false);

  const handleClose = () => { form.resetFields(); onClose(); };

  const handleFinish = async (values) => {
    try {
      await dispatch(internalUpdateStatutTicket({
        id: activeInternalStatus?.id, ticketId, type: selectedType, description: values.description,
      })).then(unwrapResult);
      setMsg('Équipe mise à jour'); setSuccess(true);
      handleClose(); onSuccess();
    } catch { setMsg("Un problème est survenu."); setError(true); }
  };

  return (
    <>
      <Dialog open={open} fullWidth maxWidth="sm" sx={{ '& .MuiPaper-root': { borderRadius: '12px' } }}>
        <DialogTitle>
          <GridContainer>
            <GridItem sx={11.5} sm={11.5} md={11.5} xl={11.5} xxl={11.5}><H4 title="Changer d'équipe" /></GridItem>
            <GridItem sx={0.5} sm={0.5} md={0.5} xl={0.5} xxl={0.5}>
              <IconButton onClick={handleClose} sx={{ color: Colors.primary }}><CloseIcon /></IconButton>
            </GridItem>
          </GridContainer>
        </DialogTitle>
        <AntForm form={form} name="header-change-team" onFinish={handleFinish}>
          <GridContainer display="flex" justifyContent="center" direction="row" gap="8px" flex="1 0 0">
            <GridItem sx={12} sm={12} md={12} xl={12} xxl={12} padding="16px 32px 0px 32px">
              <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#333', mb: 1.5 }}>
                Nouvelle équipe cible
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                {allowedTeams.map(team => (
                  <Box key={team.type} onClick={() => setSelectedType(team.type)} sx={{
                    flex: '1 1 auto', p: '10px 14px', borderRadius: '10px', cursor: 'pointer',
                    border: selectedType === team.type ? `2px solid ${team.color}` : '1.5px solid #e0e0e0',
                    backgroundColor: selectedType === team.type ? team.bg : '#fff',
                    transition: 'all 0.15s', '&:hover': { backgroundColor: team.bg, borderColor: team.color },
                  }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: selectedType === team.type ? team.color : '#444' }}>{team.label}</Typography>
                    <Typography sx={{ fontSize: 11, color: '#888' }}>{team.desc}</Typography>
                  </Box>
                ))}
              </Box>
              <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#333', mb: 1 }}>
                Description <span style={{ color: 'red' }}>*</span>
              </Typography>
              <AntForm.Item name="description" rules={[{ required: true, message: 'Ce champ est obligatoire !' }]}>
                <Input.TextArea rows={4} autoSize={{ minRows: 4, maxRows: 4 }} placeholder="Raison du changement..." />
              </AntForm.Item>
            </GridItem>
          </GridContainer>
          <DialogActions>
            <AntForm.Item style={{ marginTop: '-25px' }}>
              <Button onClick={handleClose} variant="outlined"
                sx={{ textTransform: 'none', border: '2px solid #2A66C6', color: '#2A66C6', borderRadius: '18px', width: '93px', height: '40px' }}>
                Annuler
              </Button>
              <Button type="submit" variant="contained"
                sx={{ textTransform: 'none', '&.MuiButtonBase-root': { color: '#fff', backgroundColor: '#2A66C6', borderRadius: '32px', height: '40px', width: '160px', ml: 2, mr: 3, '&:hover': { backgroundColor: '#3C3489' } } }}>
                Confirmer
              </Button>
            </AntForm.Item>
          </DialogActions>
        </AntForm>
      </Dialog>
      <Snackbars severity="success" message={msg} open={success} setOpen={setSuccess} autohideduration={2000} />
      <Snackbars severity="error"   message={msg} open={error}   setOpen={setError}   autohideduration={3000} />
    </>
  );
}

export default HeaderChangeTeamModal;